import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminBalanceAdjustmentListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveBalanceAdjustments } from "./retrieve-balance-adjustments";

const initialState: RetrievalState<AdminBalanceAdjustmentListVM[]> = { fetching: "idle", data: [] };

export const retrieveBalanceAdjustmentsReducer = createReducer<RetrievalState<AdminBalanceAdjustmentListVM[]>>(initialState, builder => {
  builder.addCase(retrieveBalanceAdjustments.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveBalanceAdjustments.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveBalanceAdjustments.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
